import { Card, Row, Col, Badge } from 'react-bootstrap';
import { formatCurrency, formatPercent } from '../../../../utils/formatters'

const ReadOnlyCalculatedBenefits = ({
  arrearsLiabilityAmount,
  originalArrears,
  incomeMeasurementType,
  incomeMeasurementPercentage,
  arrearage,
  energyDiscount,
  pledgeAmount,
  originalPledgeAmount
}) => {

  const normalizedCurrentArrears =
    arrearsLiabilityAmount !== null && arrearsLiabilityAmount !== ''
      ? Number(arrearsLiabilityAmount)
      : null;

  const normalizedOriginalArrears =
    originalArrears !== null && originalArrears !== undefined
      ? Number(originalArrears)
      : null;

  const arrearsChanged =
    normalizedCurrentArrears !== null &&
    normalizedOriginalArrears !== null &&
    normalizedCurrentArrears !== normalizedOriginalArrears;

  const normalizedPledge =
    pledgeAmount !== null && pledgeAmount !== ''
      ? Number(pledgeAmount)
      : null;

  const normalizedOriginalPledge =
    originalPledgeAmount !== null && originalPledgeAmount !== undefined
      ? Number(originalPledgeAmount)
      : null;

  const pledgeChanged =
    normalizedPledge !== null &&
    normalizedOriginalPledge !== null &&
    normalizedPledge !== normalizedOriginalPledge;

  return (
    <Card className="bg-secondary-soft">
      <Card.Header>Calculated Benefits</Card.Header>
      <Card.Body>
        {arrearsLiabilityAmount && (
          <Row>
            <Col className="text-end">
              <span>Arrears Liability Amount</span>
            </Col>
            <Col>
              <Badge bg="secondary">
                {normalizedOriginalArrears === null
                  ? '-'
                  : formatCurrency(normalizedOriginalArrears)}
              </Badge>

              {arrearsChanged && (
                <Badge bg="success" className="ms-2">
                  Updated: {formatCurrency(normalizedCurrentArrears)}
                </Badge>
              )}
            </Col>
          </Row>
        )}
        <Row>
          <Col className="text-end">
            <span>{incomeMeasurementType} Percentage</span>
          </Col>
          <Col>
            <Badge bg={incomeMeasurementPercentage? 'success': 'secondary'}>{incomeMeasurementPercentage===''? '-': formatPercent(incomeMeasurementPercentage)}</Badge>
          </Col>
        </Row>
        <Row>
          <Col className="text-end">
            <span>Arrearage</span>
          </Col>
          <Col>
            <Badge bg={arrearage? 'success': 'secondary'}>{formatPercent(arrearage)}</Badge>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col className="text-end">
            <span>Energy Discount</span>
          </Col>
          <Col>
            <Badge bg={energyDiscount? 'success': 'secondary'}>{energyDiscount === null? '-': formatPercent(energyDiscount)}</Badge>
          </Col>
        </Row>
        {(pledgeAmount !== null && pledgeAmount > 0) && (
          <Row>
            <Col className="text-end">
              <span>AMP Instant Grant Relief Amount</span>
            </Col>
            <Col>
              <Badge bg="secondary">
                {originalPledgeAmount === null
                ? '-'
                : formatCurrency(originalPledgeAmount)}
              </Badge>
              {pledgeChanged && (
                <Badge bg="success" className="ms-2">
                  Updated: {formatCurrency(normalizedPledge)}
                </Badge>
              )}
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
};

export default ReadOnlyCalculatedBenefits;